// Language registry — the single source of supported languages for the admin
// portal (take-order-i18n spec, Requirement 12.1 / 12.6).
//
// Mirrors admin-mobile-app/src/utils/i18nRegistry.js. Keep the two byte-identical:
// the Settings editor, both Take Order surfaces, and the localized-name resolver
// all read this list, and the backend `_normalize_i18n` guardrail in
// lambda/admin-product-handler/index.py enforces the SAME code set server-side.
// Adding a language means adding it here, adding its catalog entries, and adding
// it to the backend `_I18N_LANGUAGES` set — nothing else.
//
// `label` is deliberately written in the language's OWN script, because the
// language switcher is read by someone who cannot necessarily read English.
// `collation` is the Intl locale tag used to sort category chips.

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_REGISTRY = {
  en: { label: 'English', collation: 'en' },
  ta: { label: 'தமிழ்', collation: 'ta' },
};

export const LANGUAGE_CODES = Object.keys(LANGUAGE_REGISTRY);

// True for a code this build ships translations for. Used by normalizeLanguage
// and by the settings editor to render its checkboxes.
export function isRegisteredLanguage(code) {
  return Object.prototype.hasOwnProperty.call(
    LANGUAGE_REGISTRY,
    String(code || '').trim().toLowerCase()
  );
}

// Display label in the language's own script, falling back to the raw code so a
// stale stored code can never render as blank.
export function languageLabel(code) {
  const c = String(code || '').trim().toLowerCase();
  return LANGUAGE_REGISTRY[c] ? LANGUAGE_REGISTRY[c].label : c;
}

export function languageCollation(code) {
  const c = String(code || '').trim().toLowerCase();
  return LANGUAGE_REGISTRY[c] ? LANGUAGE_REGISTRY[c].collation : DEFAULT_LANGUAGE;
}
